<accordion [header]="config.header">
  <ng-container header-action>
    <i class="icon icon--medium" data-test-id="accordionEditIcon">edit</i>
    <p
      class="t-data t-link"
      (click)="toggleEdit()"
      data-test-id="accordionHeaderText"
    >
      Edit
    </p>
  </ng-container>

  @if (!isEditing) {
    @for (detail of config.details; track detail; let i = $index) {
      <div class="form-control__wrapper form-control__wrapper--inline">
        <label class="form-control__label">
          <p class="t-data" [data-test-id]="'accordionLabel_' + i">
            {{ detail.label }}
          </p>
        </label>
        <p class="t-data t-bold" [data-test-id]="'detailAccordionText_' + i">
          {{ formGroup.value | getValue: detail.prop | mask: detail.mask }}
        </p>
      </div>
    }
  }

  @if (isEditing) {
    <div class="details-accordion__wrapper">
      <form-group
        class="details-accordion__form"
        [configs]="config.groups"
        data-test-id="accordionFormGroup"
        direction="default"
        [form]="formGroup"
      >
      </form-group>
    </div>
  }
</accordion>
